import { faro, TransportItemType } from '@grafana/faro-web-sdk'
import type { EventEvent, TransportItem } from '@grafana/faro-web-sdk'
import { matchRoutes } from 'react-router-dom'
import routes from '../routes'

const isFirestoreListen = (url = '') =>
	url.includes('firestore.googleapis.com') && url.includes('/Listen/channel')

/** Drops Firestore's successful keep-alives; `ignoreUrls` would drop the failures too. */
export const dropHealthyFirestoreListens = (item: TransportItem): TransportItem | null => {
	if (item.type !== TransportItemType.EVENT) {
		return item
	}

	// The resource and tracing instrumentations use different keys for the same request
	const { attributes = {} } = item.payload as EventEvent
	const url = attributes['url.full'] ?? attributes.name
	const status = attributes['http.response.status_code'] ?? attributes.responseStatus

	return isFirestoreListen(url) && status === '200' ? null : item
}

/** The route pattern for a URL, so ids don't fragment the grouping in Grafana. */
export const getFaroViewName = (pathname: string): string => {
	const matches = matchRoutes(routes, pathname)
	const pattern = (matches ?? [])
		.map((match) => match.route.path)
		.filter(Boolean)
		.join('/')

	// The root and every unknown URL hit the terminal `*` route, whose pattern says nothing
	if (!pattern || pattern.includes('*')) {
		return pathname
	}

	// A route path with a stray trailing slash would otherwise split one view in two
	return `/${pattern}`.replace(/\/+$/, '')
}

export const setFaroView = (pathname: string) => {
	faro.api?.setView({ name: getFaroViewName(pathname) })
}

export const setFaroUser = (id: string, email: string | null) => {
	faro.api?.setUser({ id, email: email ?? undefined })
}

export const resetFaroUser = () => {
	faro.api?.resetUser()
}

export const reportFaroError = (error: Error, componentStack?: string | null) => {
	faro.api?.pushError(error, {
		type: 'ReactErrorBoundary',
		fatal: true,
		context: { componentStack: componentStack ?? '' }
	})
}
